import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function openInNewTab(
  rawUrl: string | null | undefined,
  options?: { allowData?: boolean },
) {
  if (!rawUrl) return false;

  try {
    const parsed = new URL(rawUrl, window.location.origin);
    const allowedProtocols = options?.allowData
      ? ["http:", "https:", "mailto:", "tel:", "data:"]
      : ["http:", "https:", "mailto:", "tel:"];

    if (!allowedProtocols.includes(parsed.protocol)) {
      return false;
    }

    window.open(parsed.href, "_blank", "noopener,noreferrer");
    return true;
  } catch {
    return false;
  }
}
